import { Exclude, Expose, Type } from 'class-transformer';
import { EOpening } from '../../../core/EOpening';
import { EOpeningType } from '../../../core/EOpeningType';
import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';
import type { IPushPullActionner } from './IPushPullActionner';
import { IDrawGlassDoor } from '../../../GlassDoor/IDrawGlassDoor';

export class DrawFrontDoor extends DrawCabinetFrontElement implements IPushPullActionner {
    // @Type(() => DrawGlassDoor) // Assurez-vous d'importer et de définir correctement DrawGlassDoor
    glassDoor!: IDrawGlassDoor;

    openingType: EOpeningType = EOpeningType.H;
    OpeningOrientation: EOpening = EOpening.A;
    IsPushPull: boolean = false;
}
